module.exports = __webpack_public_path__ + "img/google.4213ce61.png";